export const ADP_MASS_FLOW_METER_CHART_NS = 'components/AdpMassFlowMeterChart';

export const i18n = {
  en: {
    totalMassFlow: 'Total Mass Flow (MT)',
    totalVolumeFlow: 'Total Volume Flow (M3)',
    instantDensity: 'Instant Density (kg/m3)',
    instantMass: 'Instant Mass Flow (MT/hr)',
    instantVolume: 'Instant Volume Flow (M3/hr)',
    instantDrive: 'Instant Drive Gain (%)',
    tubeDamping: 'Tube Damping (A/m)',
  },
};
